const mapping: Record<
  string,
  (lambdaParameter: string, value: any, otherValues: any) => string | null
> = {
  description: (lambdaParameter, value) =>
    `${lambdaParameter}.Description.Contains("${value}")`,
  categoryId: (lambdaParameter, value) =>
    `${lambdaParameter}.Categories.Any(cat=>cat.Id.Equals(${value}))`,
  usersIds: (lambdaParameter, value) =>
    `${lambdaParameter}.UsersIds.Contains(${value})`,
  filterUserId: () => null,
  userId: (lambdaParameter, value, otherValues) =>
    otherValues.filterUserId === false
      ? null
      : `${lambdaParameter}.Users.Any(vd=>vd.Id==${value})`,
}

export const filterMapper = (key: string) =>
  mapping[key] as (
    lambdaParameter: string,
    value: any,
    otherValues: any,
  ) => string

export default filterMapper
